/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import Immutable from 'immutable';
import PropTypes from '../util/prop_types';
import { SidePanelSelectors } from '../stores/sidepanel_selectors';
import { SidePanelActionCreators } from '../stores/sidepanel_action_creators';
import { ViewActionCreators } from '../stores/view_action_creators';
import OmniboxSuggestions from './omnibox_suggestions';
import { keyCodes } from '../util/keycodes';

const mapStateToProps = (state) => {
  return {
    searchQuery: SidePanelSelectors.getQuery(state),
    isCollapsed: SidePanelSelectors.isCollapsed(state),
    activeId: SidePanelSelectors.getActiveId(state),
  }
}

const mapDispatchToProps = {
  setSearchQuery: SidePanelActionCreators.setQuery,
  clearSearch: SidePanelActionCreators.clear,
  toggleCollapsed: SidePanelActionCreators.toggleCollapsed,
  setActiveId: SidePanelActionCreators.setActiveId,
  toggleMenu: ViewActionCreators.toggleMenu,
}

class Omnibox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSuggestions: false,
    };
  }

  componentDidUpdate() {
    if(this.props.activeId == 0 && this.state.showSuggestions) {
      this.searchInput.focus();
    }
  }

  componentWillUnmount() {
    if (this.blurTimeout) {
      clearTimeout(this.blurTimeout);
    }
  }

  changeSearch = (e: Object) => {
    this.props.setSearchQuery(e.target.value);
  };

  onSearchFocus = () => {
    this.props.setActiveId(0);
  }

  onFocus = () => {
    if (this.props.searchQuery == '') {
      this.setState({ showSuggestions: true });
    }
    if (this.blurTimeout) {
      clearTimeout(this.blurTimeout);
    }
  }

  onBlur = () => {
    this.blurTimeout = setTimeout(() => {
      this.setState({ showSuggestions: false });
    }, 200);
  }

  onKeyUp = (e) => {
    var newActiveId = this.props.activeId;

    if (e.keyCode == keyCodes.down) {
      newActiveId++;
    }
    else if (e.keyCode == keyCodes.up) {
      newActiveId--;
    }

    this.props.setActiveId(newActiveId);
  }

  render(): ?React.Element<any> {
    const { props, state } = this;

    var className = "";

    if (props.isCollapsed) {
      className += " collapsed"
    }
    if(!!props.searchQuery) {
        className += " side-panel-visible"
    }

    return (
      <div id="omnibox-container"
        className={className}>
        <div id="omnibox"
          onBlur={this.onBlur}
          onFocus={this.onFocus} >
          <div id="searchbox">
            <button
              id="menu-button"
              aria-label="Show Menu"
              onClick={props.toggleMenu}>
              <FontAwesome
                name="navicon"
                fixedWidth
                size="lg" />
            </button>
            <button
              id="search-back"
              aria-label="Back to Map"
              onClick={props.toggleCollapsed}>
              <FontAwesome
                name="chevron-left"
                fixedWidth
                size="lg" />
            </button>
            <input autoFocus id="search-input"
              type='text'
              ref={(elm) => { this.searchInput = elm; }}
              placeholder="Search the Cal Poly Map"
              aria-label="Search the Cal Poly Map"
              autoComplete="off"
              spellCheck="false"
              autoCorrect="off"
              onChange={this.changeSearch}
              onFocus={this.onSearchFocus}
              onKeyUp={this.onKeyUp}
              value={props.searchQuery} />
            {props.searchQuery &&
              <div id="search-clear">
                <button aria-label="Clear search"
                  onClick={props.clearSearch}>
                  <FontAwesome
                    name="times"
                    size="lg" />
                </button>
              </div>
            }
          </div>
          <a id="show-results"
            tabIndex="0"
            onClick={props.toggleCollapsed} >
            Show search results
          </a>
          {!props.searchQuery && state.showSuggestions &&
            <OmniboxSuggestions
              onKeyUp={this.onKeyUp} />
          }
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Omnibox);
